import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import moment from "moment";

function Struktur() {
    const navigate = useNavigate();

    //define state
    const [struktur, setStruktur] = useState([]);

    //function "fetchData"
    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            // fetching
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/structure/readStruktur`
            );
            // get response data
            const data = response.data;
            // assign response data to state "Customer"
            setStruktur(data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error, e.g., show a struktur-friendly message
        }
    };

    useEffect(() => {
        //panggil method "fetchData"
        fetchData();
    }, []);

    const handleDelete = async (id_struktur) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Make axios delete request
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/structure/deleteStruktur/${id_struktur}`
                    );

                    // Refetch data after successful delete
                    fetchData();

                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Foto",
            selector: (row) => (
                <img
                    src={
                        row.foto.startsWith("http")
                            ? row.foto
                            : `${process.env.REACT_APP_API_URL}/structure/uploads/${row.foto}`
                    }
                    alt="struktur"
                    style={{ width: " 100px", height: "70px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Tanggal",
            selector: (row) => moment(row.tanggal).format("YYYY-MM-DD"),
            sortable: true,
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={`/strukturEdit/${row.id_struktur}`} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button
                        onClick={() => handleDelete(row.id_struktur)}
                        className="btn btn-danger"
                    >
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Struktur</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data Struktur</h3>
                                    </div>
                                    <div className="card-body">
                                        <Link to="/strukturAdd" className="btn btn-primary">
                                            <i className="nav-icon fas fa-plus mr-2" />
                                            Add Data
                                        </Link>
                                        <DataTable columns={columns} data={struktur} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Struktur;
